import { ApiService } from '../ApiService';
import { User } from '../../entities/User';

export class UserSelectionService {
  public static list(): Promise<User[]> {
    return ApiService.get<User[]>('/api/user_selection');
  }
}
